export enum AI_GENERATED_CONTENT {
    /**
     * @value Article...
     */
    CHIP_ARTICLE = 'WREX_AI.CHIP_ARTICLE',
    /**
     * @value Casual
     */
    CHIP_FORMALITY_CASUAL = 'WREX_AI.CHIP_FORMALITY_CASUAL',
    /**
     * @value Formal
     */
    CHIP_FORMALITY_FORMAL = 'WREX_AI.CHIP_FORMALITY_FORMAL',
    /**
     * @value Neutral
     */
    CHIP_FORMALITY_NEUTRAL = 'WREX_AI.CHIP_FORMALITY_NEUTRAL',
    /**
     * @value Internal Communication...
     */
    CHIP_INTERNAL_COMMUNICATION = 'WREX_AI.CHIP_INTERNAL_COMMUNICATION',
    /**
     * @value Job offer...
     */
    CHIP_JOB_OFFER = 'WREX_AI.CHIP_JOB_OFFER',
    /**
     * @value Plan...
     */
    CHIP_PLAN = 'WREX_AI.CHIP_PLAN',
    /**
     * @value Start thinking about…
     */
    CHIP_START_THINKING_ABOUT = 'WREX_AI.CHIP_START_THINKING_ABOUT',
    /**
     * @value Confident
     */
    CHIP_TONE_CONFIDENT = 'WREX_AI.CHIP_TONE_CONFIDENT',
    /**
     * @value Direct
     */
    CHIP_TONE_DIRECT = 'WREX_AI.CHIP_TONE_DIRECT',
    /**
     * @value Friendly
     */
    CHIP_TONE_FRIENDLY = 'WREX_AI.CHIP_TONE_FRIENDLY',
    /**
     * @value Humorous
     */
    CHIP_TONE_HUMOUROUS = 'WREX_AI.CHIP_TONE_HUMOUROUS',
    /**
     * @value Positive
     */
    CHIP_TONE_POSITIVE = 'WREX_AI.CHIP_TONE_POSITIVE',
    /**
     * @value Professional
     */
    CHIP_TONE_PROFESSIONAL = 'WREX_AI.CHIP_TONE_PROFESSIONAL',
    /**
     * @value Supportive
     */
    CHIP_TONE_SUPPORTIVE = 'WREX_AI.CHIP_TONE_SUPPORTIVE',
    /**
     * @value To-do list...
     */
    CHIP_TO_DO_LIST = 'WREX_AI.CHIP_TO_DO_LIST',
    /**
     * @value Build your content prompt
     */
    DIALOG_SUBTITLE = 'WREX_AI.DIALOG_SUBTITLE',
    /**
     * @value Display suggested prompts
     */
    DISPLAY_SUGGESTED_PROMPTS = 'WREX_AI.DISPLAY_SUGGESTED_PROMPTS',
    /**
     * @value Formality
     */
    FORMALITY = 'WREX_AI.FORMALITY',
    /**
     * @value AI generative content
     */
    GENERATE_CONTENT_BUTTON = 'WREX_AI.GENERATE_CONTENT_BUTTON',
    /**
     * @value Content description
     */
    GENERATE_CONTENT_DESC = 'WREX_AI.GENERATE_CONTENT_DESC',
    /**
     * @value Tips for a good prompt:
     */
    GENERATE_CONTENT_TIPS = 'WREX_AI.GENERATE_CONTENT_TIPS',
    /**
     * @value Describe briefly the content you would like to get
     */
    GENERATE_CONTENT_TIPS_1 = 'WREX_AI.GENERATE_CONTENT_TIPS_1',
    /**
     * @value Add as many keywords as you can
     */
    GENERATE_CONTENT_TIPS_2 = 'WREX_AI.GENERATE_CONTENT_TIPS_2',
    /**
     * @value Ask questions
     */
    GENERATE_CONTENT_TIPS_3 = 'WREX_AI.GENERATE_CONTENT_TIPS_3',
    /**
     * @value AI generated content
     */
    GENERATE_CONTENT_TITLE = 'WREX_AI.GENERATE_CONTENT_TITLE',
    /**
     * @value Generate text
     * @description Label used to indicate the text can be generated with AI
     */
    GENERATE_TEXT = 'AI.GENERATE_TEXT',
    /**
     * @value Write about...
     */
    INPUT_PLACEHOLDER = 'WREX_AI.INPUT_PLACEHOLDER',
    /**
     * @value Write an article about
     */
    PROMPT_ARTICLE = 'WREX_AI.PROMPT_ARTICLE',
    /**
     * @value Please use a casual level of formality, as if you were chatting with a friend or in a relaxed, informal setting.
     */
    PROMPT_FORMALITY_CASUAL = 'WREX_AI.PROMPT_FORMALITY_CASUAL',
    /**
     * @value Please maintain a formal level of formality in your responses, ensuring that they are professional and respectful, suitable for formal or business contexts.
     */
    PROMPT_FORMALITY_FORMAL = 'WREX_AI.PROMPT_FORMALITY_FORMAL',
    /**
     * @value Please maintain a neutral level of formality in your responses, striking a balance between casual and formal, suitable for a professional yet approachable tone.
     */
    PROMPT_FORMALITY_NEUTRAL = 'WREX_AI.PROMPT_FORMALITY_NEUTRAL',
    /**
     * @value Write an internal communication about
     */
    PROMPT_INTERNAL_COMMUNICATION = 'WREX_AI.PROMPT_INTERNAL_COMMUNICATION',
    /**
     * @value Write a job offer about
     */
    PROMPT_JOB_OFFER = 'WREX_AI.PROMPT_JOB_OFFER',
    /**
     * @value Your prompt
     */
    PROMPT_LABEL = 'WREX_AI.PROMPT_LABEL',
    /**
     * @value Write the prompt in the language of your desired text.
     * @description Generative text prompt tips to tell the user concerning the language used in the generation.
     */
    PROMPT_LANGUAGE_TIPS = 'AI.PROMPT_LANGUAGE_TIPS',
    /**
     * @value Write a plan about
     */
    PROMPT_PLAN = 'WREX_AI.PROMPT_PLAN',
    /**
     * @value Prompt is required. To generate content, enter a prompt.
     * @description Error text displayed on the prompt input to generative text with AI. This indicate to the user that a prompt is always required.
     */
    PROMPT_REQUIRED_ERROR = 'AI_GENERATIVE_TEXT.PROMPT_REQUIRED_ERROR',
    /**
     * @value Start thinking about
     */
    PROMPT_START_THINKING_ABOUT = 'WREX_AI.PROMPT_START_THINKING_ABOUT',
    /**
     * @value Start writing about...
     * @description A label used on a suggestion chip of AI generative content, in order to help the users to start writing his prompt.
     */
    PROMPT_SUGGESTION_LABEL_WRITING_ABOUT = 'AI_GENERATIVE_TEXT.PROMPT_SUGGESTION_LABEL_WRITING_ABOUT',
    /**
     * @value Start writing about
     * @description A text used to prefill a prompt for an AI generative content.
     */
    PROMPT_SUGGESTION_RESULT_WRITING_ABOUT = 'AI_GENERATIVE_TEXT.PROMPT_SUGGESTION_RESULT_WRITING_ABOUT',
    /**
     * @value Please use a confident tone, ensuring that the information is delivered with authority and self-assuredness.
     */
    PROMPT_TONE_CONFIDENT = 'WREX_AI.PROMPT_TONE_CONFIDENT',
    /**
     * @value Please maintain a direct and concise tone, focusing on delivering information succinctly and without unnecessary elaboration.
     */
    PROMPT_TONE_DIRECT = 'WREX_AI.PROMPT_TONE_DIRECT',
    /**
     * @value Use conversational voice and tone. Imagine you're talking to a friend and use natural language and phrasing.
     */
    PROMPT_TONE_FRIENDLY = 'WREX_AI.PROMPT_TONE_FRIENDLY',
    /**
     * @value Use a humorous voice and tone, include jokes, and write with irony when appropriate.
     */
    PROMPT_TONE_HUMOUROUS = 'WREX_AI.PROMPT_TONE_HUMOUROUS',
    /**
     * @value Please adopt a positive and upbeat tone, focusing on optimism, encouragement, and a can-do attitude.
     */
    PROMPT_TONE_POSITIVE = 'WREX_AI.PROMPT_TONE_POSITIVE',
    /**
     * @value Please use a professional tone, ensuring that it is respectful and suitable for formal or business contexts.
     */
    PROMPT_TONE_PROFESSIONAL = 'WREX_AI.PROMPT_TONE_PROFESSIONAL',
    /**
     * @value Please utilize a supportive tone, showing empathy, encouragement, and a willingness to assist and uplift the user.
     */
    PROMPT_TONE_SUPPORTIVE = 'WREX_AI.PROMPT_TONE_SUPPORTIVE',
    /**
     * @value A prompt is a short phrase that guides the AI in creating content.
     */
    PROMPT_TOOLTIP = 'WREX_AI.PROMPT_TOOLTIP',
    /**
     * @value Write a to-do list about
     */
    PROMPT_TO_DO_LIST = 'WREX_AI.PROMPT_TO_DO_LIST',
    /**
     * @value Describe in your own words the content you expect.
     */
    TIPS_1 = 'WREX_AI.DIALOG_TIPS_1',
    /**
     * @value Add as many relevant keywords as possible.
     */
    TIPS_2 = 'WREX_AI.DIALOG_TIPS_2',
    /**
     * @value Tone of voice
     */
    TONE = 'WREX_AI.TONE',
}
